/**
 * ReservationStepper Feature Component
 * Displays the 3-step reservation process
 */

'use client'

import { StepIndicator } from '@/components/atoms/StepIndicator'
import { cn } from '@/lib/utils'

interface Step {
	number: number
	label: string
}

interface ReservationStepperProps {
	currentStep: number
	onStepClick?: (step: number) => void
	className?: string
}

const steps: Step[] = [
	{ number: 1, label: 'Selecciona\nun vehículo' },
	{ number: 2, label: 'Adicional' },
	{ number: 3, label: 'Finaliza\ntu reserva' },
]

export function ReservationStepper({
	currentStep,
	onStepClick,
	className,
}: ReservationStepperProps) {
	return (
		<div
			className={cn(
				'w-full overflow-x-auto py-8 px-[3%] bg-white scrollbar-hide',
				className,
			)}
		>
			<div className='flex items-center md:justify-center gap-4 md:gap-10 min-w-max px-4'>
				{steps.map((step, index) => {
					const isActive = currentStep === step.number
					const isCompleted = currentStep > step.number
					const isClickable = isCompleted && !!onStepClick
					return (
						<div
							key={step.number}
							className='flex items-center'
						>
							<div
								onClick={
									isClickable ? () => onStepClick(step.number) : undefined
								}
								className={cn(
									'flex items-center gap-3 md:gap-4 px-4 md:px-6 py-2 md:py-3 rounded-xl border-2 transition-colors',
									isActive
										? 'bg-[#09194D] border-[#09194D]'
										: 'bg-white border-[#09194D]',
									isClickable && 'cursor-pointer hover:bg-gray-50',
								)}
							>
								<StepIndicator
									number={step.number}
									isActive={isActive}
									isCompleted={isCompleted}
									className='w-8 h-8 md:w-10 md:h-10'
								/>
								<span
									className={cn(
										'font-["Bricolage_Grotesque"] text-sm md:text-lg font-black leading-tight whitespace-pre-line',
										isActive ? 'text-[#CDFF00]' : 'text-[#09194D]',
									)}
								>
									{step.label}
								</span>
							</div>
						</div>
					)
				})}
			</div>
		</div>
	)
}
